import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Route,
} from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'lodash';
import { appComponents } from '../components';
import * as style from './styles.scss';
import FooterComponent from '../components/footer';
import { refreshCurrentActiveProgram, refreshUserPermissionWithoutRefresh, getHelpCentreDetails } from '../actions/userActions';
import { getExternalModules } from '../components/externalModules/actions';
import ModuleRouteBound from './moduleRouteOutlet';

class WrapperView extends Component {
  componentDidUpdate(prevProp) {
    if (this.props.location.search !== prevProp.location.search) {
      window.scrollTo(0, 0);
    }
  }

  getModuleInjectedProps() {
    const userPermissions = this.props.currentActiveProgram && this.props.roleSelected ?
      _.filter(this.props.currentActiveProgram.permissions, p =>
        (p.action === 'view')) : undefined;
    return {
      permissions: userPermissions,
      role: this.props.roleSelected,
      userDetail: this.props.userDetail,
      currentActiveProgram: this.props.currentActiveProgram,
      refreshCurrentActiveProgram,
      refreshUserPermissionWithoutRefresh,
      getHelpCentreDetails,
      refreshExternalModules: getExternalModules,
    };
  }

  render() {
    return (
      <Route exact={this.props.exact} path={this.props.path}>
        <div className="wrapper">
          {this.props.userDetail && this.props.numberModuleWillBeLoad === 0 ?
            <Route component={appComponents.Banner} /> :
            null}
          <div className="subwrapper">
            {this.props.navBar ? <Route component={appComponents.NavBar} /> : null}
            <div className={`main-content-panel ${style['main-container']}`}>
              <ModuleRouteBound
                component={this.props.component}
                authenticated={this.props.authenticated}
                locationSearch={this.props.location.search}
                requireRoleInQuery
                injectedProps={this.getModuleInjectedProps()}
              />
            </div>
          </div>
          <footer>
            { !this.props.isPMI && this.props.userDetail
            && this.props.numberModuleWillBeLoad === 0 ?
              <FooterComponent /> : null
            }
          </footer>
        </div>
      </Route>
    );
  }
}
const mapStateToProps = state => ({
  userDetail: state.UserDetail.get('userDetail'),
  currentActiveProgram: state.UserDetail.get('currentActiveProgram'),
  roleSelected: state.UserDetail.get('roleSelected'),
  isPMI: state.LoginReducer.get('isPMI'),
  numberModuleWillBeLoad: state.ModuleLoader.get('numberModuleWillBeLoad'),
});

export default connect(
  mapStateToProps,
  null,
)(WrapperView);

WrapperView.propTypes = {
  navBar: PropTypes.bool,
  exact: PropTypes.bool,
  authenticated: PropTypes.bool,
  component: PropTypes.func.isRequired,
  path: PropTypes.string,
  userDetail: PropTypes.shape({}),
  currentActiveProgram: PropTypes.shape({
    permissions: PropTypes.shape({}),
    roleNames: PropTypes.shape(PropTypes.string),
  }),
  roleSelected: PropTypes.shape(),
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
  }).isRequired,
  isPMI: PropTypes.bool.isRequired,
  numberModuleWillBeLoad: PropTypes.number,
};

WrapperView.defaultProps = {
  navBar: false,
  exact: false,
  authenticated: false,
  path: undefined,
  userDetail: undefined,
  currentActiveProgram: undefined,
  roleSelected: undefined,
  numberModuleWillBeLoad: -1,
};
